/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'navigation.global-shortcuts.all-sites': '모든 사이트',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': '닫기',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(현재 사용할 수 없음)',
  'navigation.global-shortcuts.sites': '{productName} 사이트',
};
